import React, { useEffect } from "react"
import { I18nextProvider } from "react-i18next"

import i18n, { initLanguage } from "./config"

const I18nRoot = ({ children }) => {
  // Applied after mount, not at init: the pages are pre-rendered in the default
  // locale, so switching any earlier would make the first client render
  // disagree with the server HTML. See initLanguage in ./config.js.
  useEffect(() => {
    initLanguage()
  }, [])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

// Shared by gatsby-browser.js and gatsby-ssr.js so the build-time render and the
// hydrated client tree use the same i18next instance.
export const wrapRootElement = ({ element }) => <I18nRoot>{element}</I18nRoot>
